import { useQuery } from '@apollo/client';
import React, { FC, useEffect } from 'react';

import { IPageProps } from '@folx-types/flow-steps';

import GET_CONTACTS from '@graphql/queries/getEmergencyContacts.query.gql';

import EmergencyContacts from './EmergencyContacts.component';

interface IEmergencyContactsPageProps extends IPageProps {}

const EmergencyContactsPage: FC<IEmergencyContactsPageProps> = ({ path }) => {
	const { data, loading, error, refetch } = useQuery(GET_CONTACTS);
	const contacts = data?.emergencyContacts?.nodes;

	useEffect(() => {
		refetch();
	}, []);

	return <EmergencyContacts path={path} contacts={contacts} loading={loading} />;
};

export default EmergencyContactsPage;
